import React, { Fragment, useEffect, useState } from "react";
import Container from "@/components/container/Container";
import { Breadcrumb, Col, Flex, Popover, Row } from "antd";
import "@/styles/pages/guide/guideProfile.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import IconShare from "@/components/icons/IconShare";
import IconVerified from "@/components/icons/IconVerified";
import IconSchoolCollege from "@/components/icons/IconSchoolCollege";
import IconBook from "@/components/icons/IconBook";
import IconTravelLang from "@/components/icons/IconTravelLang";
import ButtonComponent from "@/components/button/Button";
import PreviewComponent from "@/components/preview/PreviewComponent";
import { useDispatch } from "react-redux";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useNavigate, useParams } from "react-router-dom";
import { setCurrentGuide } from "@/reducers/guideSlice";
import { getGuideProfile } from "@/services/guides/getGuideProfile";
import useTriggerNotification from "@/hooks/useTriggerNotification";
import IconDots from "@/components/icons/IconDots";
import IconReport from "@/components/icons/IconReport";
import { crateReport } from "@/services/users/getReportCategory";
import getCountryISO2 from "@/lib/data/isoThreeToTwo";

let dummyData = {
  _id: "123",
  profilePicture: "",
  name: "",
  region: [
    {
      countryName: "ind",
      cityName: "Delhi",
    },
    {
      countryName: "gbr",
      cityName: "London",
    },
  ],
  collegeName: "London School of Economics",
  courseName: "International Development",
  languageKnown: "English, Hindi & Tamil",
  availability: "Available Today, 08:00pm IST",
  description: "                           ",
  introVideoLink: "/assets/SampleVideo.mp4",
  skills: ["SOP Writing", "Puzzle Solving", "Resume Structure", "LOR Structuring"],
  speaks: ["English", "Hindi", "Tamil"],
  interest: ["Singing", "Cycling", "Football", "Dancing", "Puzzle"],
  qualification: ["12th: DAV Public School, Mumbai,India", "B.tech: IIT Bombay, Mumbai, India"],
};
const GuideProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { trigger, element } = useTriggerNotification();
  const [guideData, setGuideData] = useState(dummyData);
  const handleBookCall = () => {
    dispatch(setModalOpen(true));
    dispatch(setCurrentGuide(guideData));
    dispatch(setCurrentForm("bookASession"));
  };
  // const { state } = useLocation();
  // console.log(state, "state");
  // useEffect(() => {
  //   if (state?.guideData) {
  //     setGuideData((prevstate) => ({
  //       ...prevstate,
  //       ...state.guideData,
  //       id: state.guideData.id,
  //       name: state.guideData.name,
  //       region: [
  //         {
  //           countryName: state.guideData?.country?.code,
  //           cityName: state.guideData?.country?.name,
  //         },
  //       ],
  //       collegeName: state.guideData?.university?.name,
  //       courseName: state.guideData?.courseName,
  //       languageKnown: state.guideData?.languages
  //         ?.map((x) => x.name)
  //         ?.join(", "),
  //       description: `Hi, ${state.guideData.name} , a student at the ${state.guideData?.university?.name}. I specialize in guiding students like you through the grad school admissions process quickly and efficiently. Let's work together to make your journey smooth, focused, enjoyable, and completely stress-free!`,
  //       skills: state.guideData?.skills?.map((x) => x.name),
  //       speaks: state.guideData?.languages?.map((x) => x.name),
  //       interest: state.guideData?.interests?.map((x) => x.name),
  //       qualification: [
  //         "12th: DAV Public School, Mumbai,India",
  //         "B.tech: IIT Bombay, Mumbai, India",
  //       ],
  //     }));
  //   }
  // }, [state]);

  const { id, fullname, countrycode } = useParams();
  const fetchData = () => {
    console.log("res :: ", id);
    getGuideProfile(id)
      .then((res) => {
        console.log(res);
        // Extract firstName and lastName from fullname in the URL
        const [firstNameFromURL, lastNameFromURL] = fullname.split("-");

        // Verify fullname and countrycode
        if (
          res.firstName.toLowerCase() !== firstNameFromURL.toLowerCase() ||
          res.lastName.toLowerCase() !== lastNameFromURL.toLowerCase() ||
          res.country?.code.toLowerCase() !== countrycode.toLowerCase()
        ) {
          console.error("URL parameters do not match the fetched mentor data.");
          navigate("/"); // Redirect to homepage if verification fails
          return;
        }
        const qualification = [];
        if (
          res?.educationDetails?.level?.name &&
          (res?.educationDetails?.university?.name !== "Other" ||
            res?.educationDetails?.institutionName)
        ) {
          qualification.push(
            `${res.educationDetails.level.name} : ${
              res.educationDetails.university?.name !== "Other"
                ? res.educationDetails.university?.name
                : res.educationDetails.institutionName
            }`
          );
        }
        setGuideData({
          id: res.id,
          name: res.firstName + " " + res.lastName,
          guideName: res.firstName + " " + res.lastName,
          firstName: res.firstName,
          lastName: res.lastName,
          profilePicture: res.profileImgUrl ?? "/assets/images/guides.svg",
          introVideoLink: res.introVidUrl.signedUrl,
          introVidThumbUrl: res.introVidThumbUrl.signedUrl,
          region: [
            {
              countryName: res?.country?.code,
              cityName: res?.country?.name,
            },
            {
              countryName: res?.countryOfOrigin?.code,
              cityName: res?.countryOfOrigin?.name,
            },
          ],
          collegeName: res?.university?.name,
          discipline: res?.discipline?.name,
          courseName: res?.courseName,
          languageKnown: res?.languages.map((x) => x.name)?.join(", "),
          description: res?.aboutMe,
          // description: `Hi, ${
          //   res.firstName + " " + res.lastName
          // } , a student at the ${
          //   res?.university?.name
          // }. I specialize in guiding students like you through the grad school admissions process quickly and efficiently. Let's work together to make your journey smooth, focused, enjoyable, and completely stress-free!`,
          skills: res?.skills.map((x) => x.name),
          speaks: res?.languages.map((x) => x.name),
          interest: res?.interests.map((x) => x.name),
          qualification,
        });
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const handleCopyToClipboard = (id) => {
    const path = window.location.href;
    navigator.clipboard.writeText(path).then(() => {
      trigger({
        type: "success",
        message: "Copied to Clipboard",
      });
    });
  };
  const onReportClick = (mentorId) => {
    dispatch(setCurrentForm("report"));
    dispatch(
      setFormProps({
        categoryType: "Mentor",
        handleSubmit: (data) => {
          if (data.categoryId && data.description) {
            data.metadata = { mentorId };
            crateReport(data).then((res) => {
              console.log(res);
              dispatch(setModalOpen(false));
              dispatch(setCurrentForm("successModal"));
              dispatch(setModalOpen(true));
              dispatch(
                setFormProps({
                  message: "Your report has been submitted successfully.",
                  btnLabel: "Close",
                  onSubmit: () => {
                    dispatch(setModalOpen(false));
                  },
                })
              );
            });
          }
        },
      })
    );
    dispatch(setModalOpen(true));
  };

  const content = ({ id }) => {
    return (
      <div className="menulink-popover">
        <Flex
          align="center"
          gap="0.5rem"
          className="color-brand cursor-pointer"
          onClick={() => {
            // dispatch(setModalOpen(true))
          }}
        >
          <IconReport />
          <span onClick={() => onReportClick(id)}>Report</span>
        </Flex>
      </div>
    );
  };
  return (
    <Fragment>
      {element}
      <Container className={"guide-profile-container"}>
        <div className="breadCrumbContainer">
          <Breadcrumb
            separator=">"
            items={[
              {
                title: "Home",
                href: "/",
              },
              {
                title: "Mentors",
                href: "/guides",
              },
              {
                title: "Mentor List",
                href: "/guide-list",
              },
              {
                title: "Mentor Profile",
              },
            ]}
          />
        </div>
        <div className="content-wrapper">
          <div className="content-card">
            {/* <div className="top-card">
          </div> */}
            <Flex className="offset" vertical gap="1.25rem">
              <Flex justify="space-between" className="content-wrapper">
                <BackWithLabel path="/guide-list" />
                <div>
                  <IconShare className="cursor-pointer" onClick={handleCopyToClipboard} />
                  <Popover
                    placement="bottomRight"
                    content={content({
                      id: guideData.id,
                    })}
                    // open={openId === index}
                    trigger="hover"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconDots className="cursor-pointer" style={{ marginLeft: "10px" }} on />
                  </Popover>
                </div>
              </Flex>
              <Flex className="guide-primary-details-wrapper content-wrapper common-card">
                <div className="guide-picture-wrapper">
                  <img src={guideData.profilePicture} />
                </div>
                <Flex justify="space-between" className="right-container">
                  <div className="guide-personal-details-wrapper">
                    <Flex align="center">
                      <div className="title-h4">{guideData.name}</div>
                      <IconVerified />
                    </Flex>
                    <Flex vertical gap="large" className="guide-sub-details">
                      <Flex>
                        {guideData.region?.map((region, index) => {
                          return (
                            <Flex align="center" gap="small" key={"region" + index}>
                              <img
                                src={`https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${getCountryISO2(
                                  region.countryName?.toUpperCase()
                                )}.svg`}
                                height={30}
                                width={30}
                              />
                              <span className="body-b12">{region.cityName}</span>
                              {index < guideData.region?.length - 1 ? (
                                <span className="divider">|</span>
                              ) : (
                                <></>
                              )}
                            </Flex>
                          );
                        })}
                      </Flex>
                      <Flex vertical gap="middle" className="guide-uni-detail">
                        <Flex className="body-b12" gap="small">
                          <IconSchoolCollege /> <span>{guideData.collegeName}</span>
                        </Flex>
                        <Flex className="body-b12" gap="small">
                          <IconBook />
                          <span>
                            {guideData.discipline === "Other" || !guideData.discipline
                              ? guideData.courseName
                              : guideData.discipline}
                          </span>
                        </Flex>
                        <Flex className="body-b12" gap="small">
                          <IconTravelLang /> <span>{guideData.speaks?.join(",")}</span>
                        </Flex>
                      </Flex>
                    </Flex>
                  </div>
                  <Flex
                    style={{ flexDirection: "column-reverse" }}
                    align="center"
                    gap="8px"
                    className="button-wrapper"
                  >
                    <span className="body-b4 guideAvalibility">{guideData.availability}</span>
                    <ButtonComponent
                      label="Book a Call"
                      varient="primary"
                      className="book-session-button"
                      onClick={handleBookCall}
                    />
                  </Flex>
                </Flex>
              </Flex>
              <Flex className="content-wrapper">
                <div className="row-spacing">
                  <Col xs={24} lg={12} className="intro-col">
                    <Flex vertical className="intro-section common-card">
                      <Flex vertical>
                        <div className="body-b1">My intro video</div>
                        <div style={{ width: "100%" }}>
                          <PreviewComponent
                            url={guideData.introVideoLink}
                            img_url={guideData.introVidThumbUrl}
                            type="video"
                          />
                        </div>
                      </Flex>
                      <Flex>
                        <div className="about-me-card">
                          <div className="body-b1">About me:</div>
                          <div>{guideData.description}</div>
                        </div>
                      </Flex>
                    </Flex>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Row vertical className="skill-section common-card">
                      <Flex vertical>
                        <div className="body-b1">{guideData.name} skills</div>
                        <Flex wrap gap="12px" className="chip-wrapper">
                          {guideData.skills?.map((skill) => {
                            return (
                              <div className="chip break-word" key={skill}>
                                {skill}
                              </div>
                            );
                          })}
                        </Flex>
                      </Flex>
                      <Flex vertical>
                        <div className="body-b1">{guideData.name} speaks</div>
                        <Flex wrap gap="12px" className="chip-wrapper">
                          {guideData.speaks?.map((speaks) => {
                            return (
                              <div className="chip break-word" key={speaks}>
                                {speaks}
                              </div>
                            );
                          })}
                        </Flex>
                      </Flex>
                      <Flex vertical>
                        <div className="body-b1">{guideData.name} interests</div>
                        <Flex wrap gap="12px" className="chip-wrapper">
                          {guideData.interest?.map((interest) => {
                            return (
                              <div className="chip break-word" key={interest}>
                                {interest}
                              </div>
                            );
                          })}
                        </Flex>
                      </Flex>
                      {guideData.qualification.length > 0 && (
                        <Flex vertical>
                          <div className="body-b1">{guideData.name} qualifications</div>
                          <Flex wrap gap="12px" className="chip-wrapper">
                            {guideData.qualification.map((qualification) => (
                              <div className="chip break-word" key={qualification}>
                                {qualification}
                              </div>
                            ))}
                          </Flex>
                        </Flex>
                      )}
                    </Row>
                  </Col>
                </div>
              </Flex>
            </Flex>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default GuideProfile;
